import React from "react"

import Airtable from "airtable"

import { ChildSelector } from "../helpers/ChildSelector"
import Spinner from "./_base/Spinner"

import { Trans, useTranslation } from "gatsby-plugin-react-i18next"

import moment from "moment"

import * as coursesAgendaStyles from "../styles/CoursesAgenda.module.css"

const filterCoursePerCat = (courseData, courseDataKey, filters) => {
  if (!filters || filters.length === 0) return true

  return filters.includes(courseData[courseDataKey])
}

const filterCourses = (coursesData, activeFilters) => {
  if (!activeFilters || activeFilters.length === 0) return coursesData

  return coursesData.filter(courseData => {
    return (
      filterCoursePerCat(courseData, `EventName`, activeFilters.courses) &&
      // filterCoursePerCat(courseData, `Type`, activeFilters.types) &&
      filterCoursePerCat(courseData, `EventLocation`, activeFilters.regions)
    )
  })
}

const categoryMap = (cat, t) => {
  if (cat)
    switch (cat.toLowerCase()) {
      case `regions`:
        return t(`Time friendly for these regions`)
      default:
        return cat
    }

  return cat
}

export const CoursesAgenda = props => {
  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const { t } = useTranslation()

  const [coursesData, setCoursesData] = React.useState(null)

  const [metadataFilters, setMetadataFilters] = React.useState([])

  const emptyActiveFilters = {
    courses: [],
    // types: [],
    regions: [],
  }
  const [activeFilters, setActiveFilters] = React.useState(emptyActiveFilters)

  const fetchData = async (sortingField = `When`, sortingDirection = `asc`) => {
    const base = new Airtable({
      apiKey: process.env.GATSBY_AIRTABLE_READ_ONLY_API_TOKEN,
    }).base("app64aystpXlVOsyl")

    let data = []
    base("OnlineSchedule")
      .select({
        view: "Grid view",
        sort: [{ field: sortingField, direction: sortingDirection }],
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          records.forEach(function (record) {
            if (record.fields) data.push(record.fields)
          })

          // To fetch the next page of records, call `fetchNextPage`.
          // If there are more records, `page` will get called again.
          // If there are no more records, `done` will get called.
          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }

          setCoursesData(data)
        },
      )
  }

  React.useEffect(() => {
    const fetchInitialData = async () => {
      fetchData()
    }

    Airtable.configure({ apiKey: `app64aystpXlVOsyl` })
    fetchInitialData().catch(console.error)
  }, [])

  React.useEffect(() => {
    const setupFilters = async () => {
      let filters = emptyActiveFilters

      coursesData.forEach(d => {
        if (!filters.courses.find(f => f.name === d.EventName))
          filters.courses.push({
            name: d.EventName,
            page: d.EventPage,
            pathway: d.EventPathway,
          })
        // if (!filters.types.includes(d.Type)) filters.types.push(d.Type)
        if (!filters.regions.find(f => f.name === d.EventLocation))
          filters.regions.push({ name: d.EventLocation })
      })

      setMetadataFilters(filters)
    }

    if (coursesData) setupFilters()
  }, [coursesData])

  const handleFilterToggle = ({ cat, filter }) => {
    let newActiveFilters = activeFilters

    if (activeFilters[cat].indexOf(filter) === -1) {
      newActiveFilters[cat].push(filter)
    } else {
      newActiveFilters[cat] = newActiveFilters[cat].filter(f => f !== filter)
    }

    setActiveFilters(newActiveFilters, forceUpdate())
  }

  const title = ChildSelector.select(
    props.content,
    `courses-agenda-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div className={`row ${coursesAgendaStyles.wrapper} ${props.className}`}>
      <div className={`col-12 ${coursesAgendaStyles.holder}`}>
        {/*  <div className={`row`}>
          <div className={`col-12 ${coursesAgendaStyles.sectionHeader}`}>
            <h2>{title}</h2>
          </div>
        </div> */}

        {!coursesData && (
          <div className={`row ${coursesAgendaStyles.loadingWrapper}`}>
            <div className={`col-12 ${coursesAgendaStyles.loading}`}>
              <Spinner message={`Loading the schedule, very busy one`} />
            </div>
          </div>
        )}

        <div className={`row ${coursesAgendaStyles.filters}`}>
          {Object.keys(metadataFilters).map((cat, idx) => (
            <div key={idx} className={`col-12 col-md-6`}>
              <p className={coursesAgendaStyles.filterCategory}>
                {categoryMap(cat, t)}
              </p>
              <div className={`row`}>
                <div className={`col-12 ${coursesAgendaStyles.filtersGrid}`}>
                  {metadataFilters[cat]
                    .reduce((acc, curr) => {
                      if (!acc.includes(curr.pathway)) acc.push(curr.pathway)
                      return acc
                    }, [])
                    .map((pathway, idx) => (
                      <div key={idx}>
                        {pathway && <p>{pathway}</p>}
                        {!pathway && (
                          <div dangerouslySetInnerHTML={{ __html: `&nbsp;` }} />
                        )}
                        {metadataFilters[cat]
                          .filter(f => f.pathway === pathway)
                          .map((filter, indx) => (
                            <span
                              key={indx}
                              className={`row ${coursesAgendaStyles.filterSelector}`}
                            >
                              <label>
                                <input
                                  type="checkbox"
                                  checked={activeFilters[cat].find(
                                    f => f.name === filter.name,
                                  )}
                                  onChange={() =>
                                    handleFilterToggle({
                                      cat,
                                      filter: filter.name,
                                    })
                                  }
                                />
                                {filter.name}
                              </label>
                            </span>
                          ))}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={`row ${coursesAgendaStyles.header}`}>
          {/* <div className={`col-12 ${coursesAgendaStyles.legend}`}>
            <Trans>OCT - Online Classroom Training</Trans>
          </div> */}
        </div>
        <div
          className={`row d-none d-lg-flex ${coursesAgendaStyles.courseItemHeader}`}
        >
          <div
            className={`col-12 d-lg-none ${coursesAgendaStyles.courseCondensedInfo}`}
          >
            <Trans>Course Information</Trans>
          </div>
          <div
            className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.course}`}
          >
            <Trans>Course</Trans>
          </div>
          <div
            className={`col-3 d-none d-lg-flex ${coursesAgendaStyles.about}`}
          >
            <Trans>About</Trans>
          </div>
          <div className={`col-1 d-none d-lg-flex ${coursesAgendaStyles.when}`}>
            <Trans>When (your local time)</Trans>
          </div>
          <div className={`col-1 d- d-lg-flex ${coursesAgendaStyles.duration}`}>
            <Trans>Duration</Trans>
          </div>
          <div
            className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.region}`}
          >
            <Trans>Event Location</Trans>
          </div>
          <div
            className={`col-1 d-none d-lg-flex ${coursesAgendaStyles.language}`}
          >
            <Trans>Language</Trans>
          </div>
          <div className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.more}`}>
            <Trans>More Information</Trans>
          </div>
        </div>

        {coursesData &&
          coursesData.length > 0 &&
          filterCourses(coursesData, activeFilters).map((cd, idx) => (
            <div
              key={idx}
              className={`row ${coursesAgendaStyles.courseItem} ${
                idx % 2 === 0 ? coursesAgendaStyles.evenRow : ``
              }`}
            >
              <div
                className={`col-12 d-lg-none ${coursesAgendaStyles.courseCondensedInfo}`}
              >
                <div className={`row ${coursesAgendaStyles.courseAndType}`}>
                  <div className={`col-12`}>
                    <span
                      className={`badge rounded-pill ${coursesAgendaStyles.courseType}`}
                    >
                      {cd.Type}
                    </span>
                    &nbsp;
                    <span
                      className={`${coursesAgendaStyles.course}`}
                      dangerouslySetInnerHTML={{ __html: cd.EventPage }}
                    ></span>
                  </div>
                </div>
                <div className={`row ${coursesAgendaStyles.whereAndWhen}`}>
                  <div className={`col-4`}>{cd.EventLocation}</div>
                  <div className={`col-8`}>
                    {moment(cd.When).format("DD MMMM yyyy - hh:mm A")}
                  </div>
                </div>
                <div className={`row ${coursesAgendaStyles.about}`}>
                  <div
                    className={`col-12`}
                    dangerouslySetInnerHTML={{ __html: cd.About }}
                  />
                </div>
              </div>
              <div
                className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.course}`}
                dangerouslySetInnerHTML={{ __html: cd.EventPage }}
              />
              <div
                className={`col-3 d-none d-lg-flex ${coursesAgendaStyles.about}`}
              >
                {cd.About}
              </div>
              <div
                className={`col-1 d-none d-lg-flex ${coursesAgendaStyles.region}`}
              >
                {moment(cd.When).format("DD MMMM yyyy - hh:mm A")}
              </div>
              <div
                className={`col-1 d-none d-lg-flex ${coursesAgendaStyles.duration}`}
              >
                {cd.Duration}
              </div>
              <div
                className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.region}`}
                dangerouslySetInnerHTML={{ __html: cd.EventLocation }}
              />
              <div
                className={`col-1 d-none d-lg-flex ${coursesAgendaStyles.language}`}
                dangerouslySetInnerHTML={{ __html: cd.Language }}
              />
              <div
                className={`col-2 d-none d-lg-flex ${coursesAgendaStyles.more}`}
                dangerouslySetInnerHTML={{ __html: cd.MoreInformation }}
              />
            </div>
          ))}
      </div>
      {/* <div className={`col-12 ${coursesAgendaStyles.holder}`}>
        <iframe
          className="airtable-embed"
          src="https://airtable.com/embed/shrqIAMHYqB0kC944?backgroundColor=purple&viewControls=on"
          frameBorder="0"
          width="100%"
          height="533"
          style={{ background: "transparent", border: "1px solid #ccc" }}
        ></iframe>
      </div> */}
    </div>
  )
}

export default CoursesAgenda
